export default __webpack_public_path__ + "static/media/Scheduling_Line.c8b2982b.svg";